import {useState, useEffect, useRef } from 'react'; 
import { useRouter } from "next/router";
import Qs from 'qs'; 
import stringifySearch from '@/lib/utils'

export default function SearchBuilder(props) {
  const router =  useRouter() 
  const [search, setSearch] = useState(props.initialSearch || {})

  const triggerSearch = (pageChange, opts={}) => ( props.search &&  props.search({...search, ...opts}, pageChange))
  const _props = {
    addValueAtKey: (key, value) => {
      setSearch((prevSearch) => { 
        delete prevSearch.page
         return   {...prevSearch, [key]: value  }
          }
      )
    }, 
    removeKey: (key) => {
      setSearch((prevSearch) => { 
        delete prevSearch[key]
        return   {...prevSearch  }
          }
      )
    }, 
    setPage: (value) => {
      setSearch(prevSearch => ({...prevSearch, ['page']: value  }))
    },

    appendPage: (value) => {
      triggerSearch(true, {page: value })
    },

     addToValuesAtKey: (key, value) => {
      setSearch(prevSearch => {
        let values = [].concat(prevSearch[key] || [])
        delete prevSearch.page
        values.push(value)
        return {...prevSearch, [key]: values}
      }
      )
    },
    removeFromValuesAtKey: (key, value) => {
      setSearch(prevSearch => {
        let values = [].concat(prevSearch[key] || [])
        delete prevSearch.page
        values = values.filter((d, i) => d !== value  )

        return {...prevSearch, [key]: values}
       })  
    },

    clearAll: () => {
      setSearch(prevSearch => ({}))
    },
    search: search, 
    humanFriendlySearch: ( ) => {
      let newObj = {} 
      Object.keys(search).forEach((key, i)  => {
        newObj[key.replace('q[', '').replace('[]', '').replace(']', '')] = search[key]
      })

      return newObj
    }, 
    triggerSearch: triggerSearch
  }


  const prevSelected = useRef();

useEffect(() => {
  if (typeof prevSelected.current !== 'undefined') {
    const pageChange = Boolean(
      search.page &&
      prevSelected.current.page !== search.page
    );

    // Keep the existing client-side fetching behavior.
    _props.triggerSearch(pageChange);

    const humanFriendlySearch = _props.humanFriendlySearch();

    const queryString =
      Object.keys(humanFriendlySearch).length > 0
        ? `?${stringifySearch(humanFriendlySearch)}`
        : '';

    const nextUrl =
      `${window.location.pathname}${queryString}`;

 if (props.useNextRouterForSearchUrl) {
  // Read the serialized filters without changing their existing format.
  // Preserve repeated query parameters as arrays.
  const nextQuery = {};

  new URLSearchParams(queryString).forEach((value, key) => {
    if (Object.prototype.hasOwnProperty.call(nextQuery, key)) {
      nextQuery[key] = [].concat(nextQuery[key], value);
    } else {
      nextQuery[key] = value;
    }
  });

  // Preserve dynamic route parameters, such as "index".
  // Do not copy all of router.query: that would retain cleared filters.
  const dynamicSegments = router.pathname.matchAll(
    /\[{1,2}(?:\.\.\.)?([^\]]+)\]{1,2}/g
  );

  for (const match of dynamicSegments) {
    const key = match[1];

    if (router.query[key] !== undefined) {
      nextQuery[key] = router.query[key];
    }
  }

  router.replace(
    {
      pathname: router.pathname,
      query: nextQuery
    },
    nextUrl,
    {
      shallow: true,
      scroll: false
    }
  ).catch((error) => {
    if (!error.cancelled) {
      console.error('[SEARCH] URL update failed', error);
    }
  });
} else {
  // Existing behavior for consumers that haven't opted in.
  window.history.pushState('', '', nextUrl);
}  }

  prevSelected.current = search;
}, [search]);

  return (<> {typeof props.children === 'function' ? props.children(_props) : props.children}</>);
}
